import React, { useEffect, useState } from "react";
import Table from "@/app/core/components/table";
import Functions from "@/app/core/util/Functions";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import AdminCompanyModal from "./components/AdminCompanyModal";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import DeleteCompanyModal from "./components/DeleteCompanyModal";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";
import List from "./components/ReclameRioEmpresas.json";
import { DateHelper } from "@/app/core/util/helpers/DateHelper";

export default function UsersControlPanel() {
  const date = new Date();
  const [data, setData] = useState([]);
  const [raw, setRaw] = useState([]);
  const [selected, setSelected] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(DateHelper.GetFirstDayOfMonth(
      date.getFullYear(),
      date.getMonth() > 0 ? date.getMonth() - 1 : date.getMonth()));
    const [endDate, setEndDate] = useState(DateHelper.GetLastDayOfMonth(
      date.getFullYear(),
      date.getMonth() < 11 ? date.getMonth() + 1 : date.getMonth()));
  const cols = [
    { header: "#ID", isSortable: true, name: "id" },
    { header: "Nome", isSortable: true, name: "name" },
    {
      header: "Verificada",
      isSortable: true,
      name: "verified",
      switch: {
        true: <span className="badge badge-success">Verificada</span>,
        false: <span className="badge badge-danger">Não verificada</span>,
      },
    },
    {
      header: "Status",
      isSortable: true,
      name: "status",
      switch: {
        0: <span className="badge badge-info">Pendente</span>,
        1: <span className="badge badge-success">Aprovada</span>,
        2: <span className="badge badge-danger">Excluída</span>,
      },
    },
    { header: "E-mail", isSortable: true, name: "email" },
    { header: "Criado em", isSortable: true, name: "createdAt" },
    { header: "Atualizado em", isSortable: true, name: "updatedAt" },
  ];

  useEffect(() => {
    loadData();
    // loadOld()
  }, [startDate, endDate]);
  

  function formatDate(date) {
    if((date + "").includes("T")){
        return date.toISOString().split("T")[0];
    }else{
        return date;
    }
}

  async function loadOld(){
    console.log(List);
    let newResults = [];

    for(let s of List){
      if(s.excluido === "n" && s.ativo === "s"){
        const newItem = {
          bio: "",
          logo: "",
          
          name: s.nome_empresa === "" && s.razao_empresa !== "" ? s.razao_empresa : s.nome_empresa,
          realName: s.razao_empresa,
          taxId: limparCNPJ(s.cnpj_empresa),
          website: formatarSite(s.site_empresa),
          phone: s.telefone_empresa !== "" ? formatarTelefone(s.telefone_empresa) : formatarTelefone(s.celular_empresa),
          email: validarEmail(s.email_empresa) === true ? s.email_empresa : "",
          verified: s.verificar !== "n" ? true : false,
          
          postalCode: "",
          neighborhood: "",
          state: "",
          street: "",
          city: "",
          status: s.ativo === "s" ? CompanyHelper.Status.Approved : CompanyHelper.Status.Pending,
          stamp: s.selo !== "" ? CompanyHelper.Stamp.Verified : CompanyHelper.Stamp.None,
          oldId: s.id_empresa ?? 0,
        };
        const exist = newResults.filter(x => x.name == newItem.name && x.realName == newItem.realName);
        if(exist.length == 0){
          newResults.push(newItem)
        }
      }
    }

    console.log("Processados", newResults);
    // fetch('./components/ReclameRioEmpresas.json')
    //   .then(response => response.json())
    //   .then(data => console.log(data))
    //   .catch(error => console.error('Erro ao carregar o JSON:', error));
  }

  function formatarSite(site) {
    // Verifica se o campo está vazio
    if (!site) return "";
    site = site.toString();
    site = site.toString().trim().replace(/\s+/g, ""); // Remove espaços

    // Converte para minúsculas se o site começar com "WWW"
    if (site.startsWith("WWW.")) {
      site = site.toLowerCase();
    }
    const regexExtensaoValida = /\.[a-zA-Z]{2,6}$/;
    if (!regexExtensaoValida.test(site)) {
      return "";
    }
    // Verifica se o site não tem o prefixo "https://"
    if (!site.startsWith("https://") && !site.startsWith("http://")) {
      site = "https://" + site;
    }
    
    return site;
  }

  function limparCNPJ(valor) {
    // Verifica se o valor está vazio ou nulo
    if (!valor) return "";

    // Converte para string caso seja numérico
    valor = valor.toString();

    // Remove pontos, traços e barras
    return valor.replace(/[.\-\/]/g, "");
}

  function formatarTelefone(telefone) {
    // Verifica se o telefone não está vazio
    if (!telefone) return telefone;
  
    // Remove todos os caracteres que não sejam números
    if(telefone.length === 0)
      return false;

    telefone = telefone.toString();

    return telefone.replace(/\D/g, '');
  }

  function validarEmail(email) {
    // Verifica se o email está vazio
    if (!email) return true; // Se estiver vazio, não quebra e retorna verdadeiro
  
    // Expressão regular para validar o formato do e-mail
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    // Verifica se o e-mail corresponde à expressão regular
    return regex.test(email);
  }

  async function loadData() {
    setLoading(true)
    CompanyController.ListByDate(new Date(startDate), new Date(endDate)).then((res) => {
        let result = [ ...res];
        for (let user of result) {
          user.createdAt = DateTranslate(user.createdDate);
          user.updatedAt = DateTranslate(user.updatedDate);
      }
      setLoading(false)
      setData(result.filter(x => x.status !== CompanyHelper.Status.Deleted));
      setRaw(result.filter(x => x.status !== CompanyHelper.Status.Deleted));
      console.log("Companies", result);
    });
  }

  async function viewAction(item) {
    setSelected(item.data);
    setShowModal(true);
  }

  function closeModal() {
    setSelected({});
    setShowModal(false);
    loadData();
  }

  function handleChange(evt) {
    const inputValue = evt.target.value;
    if (inputValue === "") {
      setData(raw);
      return;
    }

    let newResults = [];
    for (let item of raw) {

      let name = "";
      let email = "";

      item.name = item.name.toString();
      item.email = item.email.toString();

      if(item.name){
        name = item.name.toLowerCase();
      }
      if(item.email){
        email = item.email.toLowerCase();
      }

      if (name.includes(inputValue) || email.includes(inputValue)) {
        newResults.push(item);
      }
      setData(newResults);
    }
  }

  function deleteCompany(item){
    if(window.confirm(Message.DeleteConfirm)){
      setSelected(item.data);
      setShowDeleteModal(true);
    }
  }

  return (
    <>
      <div className="content">
        <div className="row">
          <div className="col-4">
            <div className="content-heading">
              <h3>Empresas</h3>
            </div>
          </div>
          <div className="col-8 row">
          <div className="form-group col-md-4">
              <span>Data de início</span>
              <input
                type="date"
                className="form-control"
                value={formatDate(startDate)}
                onChange={(evt) => setStartDate(evt.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <span>Data fim</span>
              <input
                type="date"
                className="form-control"
                value={formatDate(endDate)}
                onChange={(evt) => setEndDate(evt.target.value)}
              />
            </div>
            <div className="form-group col-md-4">
              <span>Filtrar</span>
              <div className="input-group input-group">
                <input
                  type="text"
                  onChange={(evt) => handleChange(evt)}
                  className="form-control form-control"
                  placeholder="Pesquisar..."
                />
                <div className="input-group-append">
                  <span className="input-group-text border-0 bg-body">
                    <i className="fa fa-fw fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Table
              title={`${data && data.length} Empresas`}
              loading={loading}
              data={data}
              limit={100}
              page={1}
              columns={cols}
              refreshData={() => loadData()}
              
              setFilter={(filter) => Functions.ProcessFilter(filter, data)}
              viewAction={(data) => viewAction(data)}
              deleteAction={(data) => deleteCompany(data)}
              insertAction={()=>setShowModal(true)}
            />
          </div>
        </div>
      </div>
      <AdminCompanyModal
        company={selected}
        show={showModal}
        onHide={() => closeModal()}
      />
      <DeleteCompanyModal
        company={selected}
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false) | loadData()}
      />
    </>
  );
}
